import { render, staticRenderFns } from "./RecordManageAdd.vue?vue&type=template&id=77cef742&scoped=true"
import script from "./RecordManageAdd.vue?vue&type=script&lang=js"
export * from "./RecordManageAdd.vue?vue&type=script&lang=js"
import style0 from "./RecordManageAdd.vue?vue&type=style&index=0&id=77cef742&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77cef742",
  null
  
)

export default component.exports